import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createCategory, listAllEvents } from '../../../../store/actions/achievementActions'

const AchievementCategoryCreate = () => {
  const [name, setname] = useState('')
  const [eventId, setEventId] = useState()

  const dispatch = useDispatch()
  const history = useHistory()

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createCategory(name,eventId,history))
  }

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (!userInfo.user.roles[0].name == "Super Admin") window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  useEffect(() => {
    dispatch(listAllEvents());
  }, [dispatch]);


  const { achievementEventList } = useSelector((state) => state.achievementEvent);

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Create Category</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label for="name">Name</label>
                  <input type="text" 
                    className='form-control'
                    name="name" 
                    required 
                    onChange={(e) => setname(e.target.value)} />
                </div>
                <div className='form-group'>
                  <label>Event</label>
                  <select 
                    className='form-control'
                    onChange={(e) => setEventId(e.target.value)}
                  >
                    <option disabled selected value="">Select Event</option>
                    {
                      achievementEventList?.map((item, index) => {
                        return(
                          <option value={item.id} key={index}>{item.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AchievementCategoryCreate
